import { render, staticRenderFns } from "./InstitutionalSummary.vue?vue&type=template&id=2635b606"
import script from "./InstitutionalSummary.vue?vue&type=script&lang=js"
export * from "./InstitutionalSummary.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalSummary.vue?vue&type=style&index=0&id=2635b606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports